import { VStack } from '@cad-arc';
import { RelatedDataTabExistingEvent } from '../../../event-panel/tabs/related-data/related-data-tab-existing-event';
import { useGetEventIdAndTabNameFromParams } from '../../hooks/use-get-event-id-and-tab-name-from-params';
import { FrTabContentWrapper, TOTAL_USED_PAGE_HEIGHT } from './styled';

export default function FrRelatedDataTab() {
    const { eventId } = useGetEventIdAndTabNameFromParams();

    return (
        <FrTabContentWrapper>
            {eventId && (
                <VStack
                    w="100%"
                    h={`calc(100vh - ${TOTAL_USED_PAGE_HEIGHT}px)`}
                    overflowY="auto"
                    spacing={4}
                    paddingTop="4px"
                    paddingRight="8px"
                    data-testid="fr-related-data-tab"
                >
                    <RelatedDataTabExistingEvent eventId={eventId} />
                </VStack>
            )}
        </FrTabContentWrapper>
    );
}
